const SMALL_IMAGE_SIZE_LIMIT = 250 * 1024;
const LARGE_IMAGE_SIZE_LIMIT = 500 * 1024;

const getImageIssuePriority = ({
    missingAltText,
    sizeBytes,
    hasQualityIssues = false,
}) => {
    if (missingAltText) return 0;
    if (Number(sizeBytes || 0) > LARGE_IMAGE_SIZE_LIMIT) return 1;
    if (hasQualityIssues) return 2;
    return 3;
};

const readImageSizeBytes = (image, fallbackMeta) => {
    const bytes = Number(
        image?.size_bytes ||
            image?.size ||
            image?.filesize ||
            image?.file_size ||
            fallbackMeta?.sizeBytes ||
            0
    );
    return Number.isFinite(bytes) && bytes > 0 ? bytes : 0;
};

const formatImageFileSize = (image, fallbackMeta) => {
    const bytes = readImageSizeBytes(image, fallbackMeta);
    if (!bytes) return 'Unknown Size';
    return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};

const getImageSizeBadgeState = (image, fallbackMeta) => {
    const bytes = readImageSizeBytes(image, fallbackMeta);

    if (!bytes) {
        return {
            label: 'Unknown Size',
            title: 'Unknown Size',
            className: 'bg-neutral-600/90 text-white',
            showWarning: false,
        };
    }

    const label = `${Math.max(1, Math.round(bytes / 1024))} KB`;
    if (bytes > LARGE_IMAGE_SIZE_LIMIT) {
        return {
            label,
            title: 'Heavy asset',
            className: 'bg-red-600/90 text-white',
            showWarning: true,
        };
    }

    if (bytes >= SMALL_IMAGE_SIZE_LIMIT) {
        return {
            label,
            title: 'Medium asset',
            className: 'bg-amber-500/90 text-white',
            showWarning: false,
        };
    }

    return {
        label,
        title: 'Light asset',
        className: 'bg-emerald-600/90 text-white',
        showWarning: false,
    };
};

module.exports = {
    LARGE_IMAGE_SIZE_LIMIT,
    SMALL_IMAGE_SIZE_LIMIT,
    formatImageFileSize,
    getImageIssuePriority,
    getImageSizeBadgeState,
    readImageSizeBytes,
};
